import { useState } from "react";
import classnames from "classnames";
import Modal from "components/Modal";
import PopUpSuccess from "./components/PopUpSuccess";
import ErrorModal from "./components/ErrorModal";
import BidForm from "./components/BidForm";
import AICallPreviewModal from "components/AICallPreviewModal";

import styles from "./Modals.module.scss";
import ViewRfqByIdModal from "./components/ViewRfqByIdModal/ViewRfqByIdModal";
import PopUpWarning from "./components/PopUpWarning";

const Modals = ({
  availableData,
  showModal,
  setShowModal,
  showViewRfq,
  setShowViewRfq,
  errorModal,
  setErrorModal,
  errorMessage,
  setErrorMessage,
  setLoading,
  setPercentage,
  setDisabled,
  accepted,
  setAccepted,
  id,
  setEmptyState,
  state,
  rfqData,
  byId,
  setShowByOrderId,
  byOrderIdData,
  showByOrderId,
  showAIModal,
  setShowAIModal,
  aiCallData,
  aiCallLoading
}) => {
  const [success, setSuccess] = useState(false);

  return (
    <>
      {showModal && (
        <Modal
          className={styles.modal}
          content={
            <BidForm
              setShowModal={setShowModal}
              availableData={availableData}
              setErrorModal={setErrorModal}
              setErrorMessage={setErrorMessage}
              setSuccess={setSuccess}
              setLoading={setLoading}
              setPercentage={setPercentage}
              setDisabled={setDisabled}
              setAccepted={setAccepted}
              setEmptyState={setEmptyState}
              state={state}
            />
          }
          setShowModal={setShowModal}
          hideCloseBtn={true}
          useClickOutside={false}
        />
      )}

      {accepted && <PopUpSuccess text="Success! It’s your RfQ. Let’s bid!" />}

      {success && (
        <PopUpSuccess text="You bided it! Wait for the answer and watch a new RfQ." />
      )}

      {byOrderIdData?.warning && (
        <PopUpWarning text={byOrderIdData?.warning} />
      )}

      {errorModal.state && (
        <Modal
          className={classnames(styles.errorModal, styles[errorModal.type])}
          content={
            <ErrorModal
              setShowModal={setErrorModal}
              errorMessage={errorMessage}
              setLoading={setLoading}
              setPercentage={setPercentage}
              type={errorModal.type}
              setAccepted={setAccepted}
              setDisabled={setDisabled}
              id={id}
              setEmptyState={setEmptyState}
              state={state}
              rfqData={rfqData}
              byId={byId}
            />
          }
          hideCloseBtn={true}
          setShowModal={setErrorModal}
        />
      )}
      {showViewRfq && (
        <Modal
          className={classnames(styles.viewRfqById)}
          customBackground={true}
          content={<ViewRfqByIdModal
            setShowViewRfq={setShowViewRfq}
            setShowByOrderId={setShowByOrderId}
            byOrderIdData={byOrderIdData}
            showByOrderId={showByOrderId}
            />}
          hideCloseBtn={true}
        />
      )}

      {showAIModal && (
        <Modal
          className={styles.aiCallModal}
          content={
            <AICallPreviewModal
              data={aiCallData}
              loading={aiCallLoading}
              onClose={() => setShowAIModal(false)}
            />
          }
          setShowModal={() => setShowAIModal(false)}
          hideCloseBtn={true}
        />
      )}
    </>
  );
};

export default Modals;
